import { createFileRoute } from '@tanstack/react-router'
import PropostaDetailPage from '@/pages/propostas/proposta-detail'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota index para /dashboard/$dashboardId/propostas/$propostaId
// Requer propostasAll OU propostasOwn para visualizar
// Backend filtra baseado nas capabilities
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/propostas/$propostaId/',
)({
  component: function PropostaDetailRoute() {
    const { dashboardId, propostaId } = Route.useParams()
    return (
      <ProtectedRoute
        anyOf={[CAPABILITIES.PROPOSTAS_ALL, CAPABILITIES.PROPOSTAS_OWN]}
        dashboardId={dashboardId}
      >
        <PropostaDetailPage propostaId={propostaId} dashboardId={dashboardId} />
      </ProtectedRoute>
    )
  },
})
